import * as constants from 'redux/constants/product.constants';
import * as appConstants from 'redux/constants/app.constants';
import * as cartConstants from 'redux/constants/cart.constants';

const defaultState = {
  items: [],
  loading: false,
  loadingAll: true,
  maxPrice: 0,
  mostSelled: [],
  mostRelevant: [],
  newArrivals: [],
  offers: [],
  offersItems: [],
  search: [],
  searchItems: [],
  single: null,
};

const productReducer = (state = defaultState, action) => {
  const { data, type } = action;
  switch (type) {
    case appConstants.APP_INITIALIZE_REQUESTED:
    case constants.PRODUCT_GET_ALL_OFFERS_REQUESTED:
    case constants.PRODUCT_GET_ALL_SEARCH_REQUESTED:
    case constants.PRODUCT_GET_MAX_PRICE_REQUESTED:
    case constants.PRODUCT_GET_MOST_SELLED_REQUESTED:
    case constants.PRODUCT_GET_NEW_ARRIVALS_REQUESTED:
    case constants.PRODUCT_GET_OFFERS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case constants.PRODUCT_GET_ALL_REQUESTED:
      return {
        ...state,
        loading: true,
        loadingAll: true,
      };
    case constants.PRODUCT_GET_SEARCH_REQUESTED:
      return {
        ...state,
        search: action.value.trim().length >= 3 ? state.search : [],
      };
    case constants.PRODUCT_GET_SINGLE_REQUESTED:
      return {
        ...state,
        loading: !!action.value,
        single: null,
      };
    case constants.PRODUCT_GET_ALL_SUCCEEDED:
      return {
        ...state,
        items: data.dataProducts.items,        
        mostRelevant : data.dataProducts.items.filter(item => {
          return item.new === 1;
        }).slice(-20),
        offers: data.dataProducts.offers,
        offersItems: data.dataProducts.getAllOffers,
        newArrivals: data.dataProducts.newArrivals,
        loading: false,
        loadingAll: false,
      };
    // case constants.PRODUCT_GET_ALL_OFFERS_SUCCEEDED:
    //   return {
    //     ...state,
    //     offersItems: data.items,
    //     loading: false,
    //   };
    case constants.PRODUCT_GET_ALL_SEARCH_SUCCEEDED:
      return {
        ...state,
        searchItems: data.items,
        loading: false,
      };
    case constants.PRODUCT_GET_MAX_PRICE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        maxPrice: data.item,
      };
    // case constants.PRODUCT_GET_MOST_SELLED_SUCCEEDED:
    //   return {
    //     ...state,
    //     loading: false,
    //     // mostSelled: data.items,
    //     //agarrar 10 productos al azar de productos
    //     mostSelled: state.items.sort(() => Math.random() - Math.random()).slice(0, 10),
    //   };
    // case constants.PRODUCT_GET_NEW_ARRIVALS_SUCCEEDED:
    //   return {
    //     ...state,
    //     loading: false,
    //     newArrivals: data.items,
    //   };
    // case constants.PRODUCT_GET_OFFERS_SUCCEEDED:
    //   return {
    //     ...state,
    //     loading: false,
    //     offers: data.items,
    //   };
    case constants.PRODUCT_GET_SEARCH_SUCCEEDED:
      return {
        ...state,
        search: data.items,
      };
    case constants.PRODUCT_GET_SINGLE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        single: data.item,
      };
    case cartConstants.CART_CHECKOUT_SUCCEEDED:
      return {
        ...state,
        newArrivals: state.newArrivals
          .map((item) => {
            const product = data.items.find((p) => p.itemId === item.id);
            if (product) {
              const newStock = Math.max(0, item.stock - (product.quantity || 0));     
              return { ...item, stock: newStock };
            }
            return { ...item };
          })
          .filter((item) => typeof item.stock === "number" && item.stock > 0), 

        offers: state.offers.map((item) => {
          const product = data.items.find((p) => p.itemId === item.id);
          return product ? { ...item, stock: item.stock - product.quantity } : item;
        })
        .filter((item) => item.stock > 0),
    
        mostSelled: state.mostSelled.map((item) => {
          const product = data.items.find((p) => p.itemId === item.id);
          return product ? { ...item, stock: item.stock - product.quantity } : item;
        })
        .filter((item) => item.stock > 0),

        offersItems : state.offersItems.map((item) => {
          const product = data.items.find((p) => p.itemId === item.id);
          return product ? { ...item, stock: item.stock - product.quantity } : item;
        })
        .filter((item) => item.stock > 0),

        items: state.items.map((item) => {
          const product = data.items.find((p) => p.itemId === item.id);
          return product ? { ...item, stock: item.stock - product.quantity } : item;
        })
        .filter((item) => item.stock > 0),
      };
    case constants.PRODUCT_GET_ALL_FAILED:
      return {
        ...state,
        loading: false,
        loadingAll: false,
      };
    case constants.PRODUCT_GET_ALL_OFFERS_FAILED:
    case constants.PRODUCT_GET_ALL_SEARCH_FAILED:
    case constants.PRODUCT_GET_MAX_PRICE_FAILED:
    case constants.PRODUCT_GET_MOST_SELLED_FAILED:
    case constants.PRODUCT_GET_NEW_ARRIVALS_FAILED:
    case constants.PRODUCT_GET_OFFERS_FAILED:
      return {
        ...state,
        loading: false,
      };
    case constants.PRODUCT_GET_SEARCH_FAILED:
      return {
        ...state,
        search: [],
      };
    case constants.PRODUCT_GET_SINGLE_FAILED:
      return {
        ...state,
        loading: false,
        single: null,
      };
    default:
      return state;
  }
};

export default productReducer;
